import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ContentSection from './components/ContentSection';
import ArticleCards from './components/ArticleCards';
import FaqSection from './components/FaqSection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || '';

  return (
    <div className="min-h-screen bg-background-50">
      <header>
        <Navbar />
      </header>

      <main>
        <HeroSection />
        <CategoryGrid />

        <section className="w-full bg-background-50 py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="bg-accent-50 border border-accent-200/60 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
              <div className="flex-1 text-center md:text-left">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                  Ready to Start Shopping? Browse the Full Collection
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                  Explore the complete Sugargoo Spreadsheet with thousands of curated finds across all categories. Updated daily with the latest products and trends.
                </p>
                <div className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
                  >
                    Sugargoo Spreadsheet
                    <i className="ri-external-link-line"></i>
                  </a>
                  <Link
                    to="/sugargoo-spreadsheet-guide"
                    className="flex items-center gap-2 px-6 py-3 border border-accent-300 text-accent-700 rounded-full text-sm font-medium hover:bg-white transition-all duration-200 whitespace-nowrap"
                  >
                    Read Complete Guide
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
              <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20editorial%20flatlay%20of%20curated%20fashion%20accessories%20and%20lifestyle%20products%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20elegant%20composition%2C%20warm%20neutral%20tones%2C%20no%20people%2C%20sophisticated%20aesthetic&width=400&height=400&seq=cta-section-v2&orientation=squarish"
                  alt="Sugargoo Spreadsheet shopping"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <ContentSection />
        <ArticleCards />
        <FaqSection />
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Sugargoo Spreadsheet',
            url: siteUrl ? `${siteUrl}/` : '/',
            description: 'Discover the most complete Sugargoo Spreadsheet database with curated finds, product recommendations, QC insights, shipping guides and expert reviews.',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: siteUrl ? `${siteUrl}/?q={search_term_string}` : '/?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Sugargoo Spreadsheet',
            url: siteUrl ? `${siteUrl}/` : '/',
            description: 'The most complete Sugargoo research database. Find better products, compare prices, and understand quality before buying.',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />

      <Footer />
    </div>
  );
}